import React, {} from 'react';

import BaseElement from '../base';
import { determineBaseProperties } from '../utilities';

function BlockQuote(props) {

  function renderMain() {

    const { attributes, children } = props;

    const baseElementProperties = determineBaseProperties({
      ...props,
      placeholder: 'Quote...',
      className: 'block-quote'
    });

    const blockquoteAttributes = {
      ...attributes,
      className: '',
      contentEditable: baseElementProperties.contentEditable
    };

    return <BaseElement {...baseElementProperties}>
      <blockquote {...blockquoteAttributes}>{children}</blockquote>
    </BaseElement>;

  }

  return renderMain();

}

export default BlockQuote;